import {Injectable} from '@angular/core';
import {Response, Http, RequestOptions, Headers} from '@angular/http';
import {environment} from '../../../../environments/environment';
import {Observable} from "rxjs";
import {AbstractRESTService} from "./abstract.rest.service";

@Injectable()
export class ElasticRESTService extends AbstractRESTService {
    static readonly TASK_URL ='ereg/roletype/_search';

    constructor(http: Http) {
        super(http, environment.elasticUrl, null)
    }
    protected createCustomHeaders(): RequestOptions {
        return new RequestOptions({
            headers: new Headers({
                'Authorization': 'Bearer ' +localStorage.getItem("tokenJWT")
            }),
            
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/services/rest/elastic-rest.service.ts